
import { doProcessNewControl, doDeleteElement, doDuplicateElement, doReorderPageElements } from './element';
import { quickEdit, doShowEditbar, doHideEditbar } from '../reducers/fieldSettings';
import { doDragElementEnd } from './drag-end';
import { doSaveCtrl } from './editbar';

import {
  route2NewForm,
  route2PDFForm,
  doFetchPDFForm,
  route2SavedForm,
  doFetchSavedForm,
  fetchUserOptions,
  route2TemplateForm,
  doFetchTemplateForm,
  doCheckPaymentCredentials,
  fetchCustomDocumentTemplates,
} from './form';

import {
  resetState,
  doChangePage,
  clearFieldError,
  doHideMobileSidebar,
  doShowMobileSidebar,
} from '../reducers/builder';


export default {
  quickEdit,
  doSaveCtrl,
  resetState,
  doChangePage,
  doHideEditbar,
  doShowEditbar,
  route2NewForm,
  route2PDFForm,
  doFetchPDFForm,
  clearFieldError,
  doDeleteElement,
  route2SavedForm,
  doFetchSavedForm,
  doDragElementEnd,
  fetchUserOptions,
  route2TemplateForm,
  doDuplicateElement,
  doProcessNewControl,
  doFetchTemplateForm,
  doShowMobileSidebar,
  doHideMobileSidebar,
  doReorderPageElements,
  doCheckPaymentCredentials,
  fetchCustomDocumentTemplates
};
